import React, { Suspense, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import SearchIcon from '@mui/icons-material/Search';
import ActionMenu, { Action } from '../../../components/ui/materialui/actionMenu';
import { TablaBasicFilter } from '../../../utils/tableBasicFilter';
import { TotalCartera } from '../models/totalCartera';
import { FiltroCartera } from '../models/filtroCartera';
import { OrigenDetalleMutuo, TipoFuncionalidad } from '../../../utils/enums';
import { usePermissions } from '../../../components/auth/ProtectedRoute';

interface IProps {
  cartera: TotalCartera;
  control: any;
  filtros: FiltroCartera | TablaBasicFilter;
}

const AccionesCartera: React.FC<IProps> = ({ cartera, control, filtros }) => {

  const navigate = useNavigate();
  const { hasPermission } = usePermissions();

  const handleVerClick = () => {
    navigate(`/mutuos`, { state: { nombre: cartera.nombre, idOperacion: cartera.numeroOperacion, filtros: filtros, tipoMutuo: cartera.tipoMutuo, origen: OrigenDetalleMutuo.CarteraTotal, id: cartera.id, numeroOperacion: cartera.numeroOperacion } })
  }

  const handleVerDividendos = () => {
    navigate(`/mutuos/dividendo`, { state: { nombre: cartera.nombre, idOperacion: cartera.numeroOperacion, filtros: filtros, tipoMutuo: cartera.tipoMutuo, origen: OrigenDetalleMutuo.CarteraTotal, id: cartera.id, numeroOperacion: cartera.numeroOperacion } })
  }

  const actions = useMemo<Action[]>(() => {
    const items: Action[] = [];

    if (hasPermission(TipoFuncionalidad.Cartera_ver)) {
      items.push({
        label: "Ver Mutuo",
        icon: <SearchIcon fontSize="small" />,
        onClick: handleVerClick
      });
    }


    if (hasPermission(TipoFuncionalidad.Cartera_ver)) {
      items.push({
        label: "Ver Dividendos",
        icon: <SearchIcon fontSize="small" />,
        onClick: handleVerDividendos
      });
    }

    return items;
  }, [hasPermission, cartera, filtros]);

  return (
    <>
      <ActionMenu actions={actions} />
    </>
  );
};

export default AccionesCartera;
